import * as React from 'react';
import {  } from 'reactstrap';
import { connect } from 'react-redux';
import CWSSearch from '../components/CWSSearch';
import { RouteComponentProps } from 'react-router';
import { ApplicationState } from '../store';
import * as RateSearchStore from '../store/RateSearch';
import { WelcomeText } from '../store/RateSearch';
type Props = RateSearchStore.RateSearchState
    & typeof RateSearchStore.actionCreators
    & RouteComponentProps<{}>;

class Home extends React.PureComponent<Props, any> {
    state = {
        welcomeText: [] as WelcomeText[]
    };

    // This method is called when the component is first added to the document
    public async componentDidMount() {
        await this.props.requestWelcomeText();
        this.setState({welcomeText: this.props.welcomeText})
    }

    public render() {
        const { welcomeText } = this.state; 
        return welcomeText.length == 0 ? <div className="text-center" role="status"><div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
        </div></div> : (
            <div>
                <div className="messageInformational">
                    This website may not initially contain data for all zip codes and all carriers.
                    Sample rates will be available as future rate filings are approved by the Office
                                of Insurance Regulation.
            </div>
                <br />
                <div id="welcomeText">
                    {this.state.welcomeText[0] && <div>
                        <div className="font-weight-bold" dangerouslySetInnerHTML={{ __html: welcomeText[0].title }} />

                        <div dangerouslySetInnerHTML={{ __html: welcomeText[0].description }} />
                    </div>

                    }
                    
                </div>
                <br />
                <div className="instructions">
                    <span>To find sample plans and premium rates, click
                        the "Search Medicare Supplement Rates" link below. The pages on this website are
                        printer friendly. Search results may be exported to Microsoft Excel compatible format.
                        If you need assistance with this website, please click the "Contact Us" link.</span></div>
                <ul>
                    <li><a style={{textDecoration: 'underline', color: 'black'}} href="CWSSearch"><span id="atSearchRates_lblText">Search Medicare Supplement
                        Rates</span> </a><span id="atSearchRatesDesc_lblText">- Find Medicare Supplement plans
                            and rates.</span> </li>
                    <li><a style={{ textDecoration: 'underline', color: 'black' }} href="http://www.floir.com/siteDocuments/MEDIGAPFAQs.pdf" target="MCWS_FAQ"><span id="atFAQ_lblText">
                        Frequently Asked Questions</span> </a><span id="atFaqDesc_lblText">- A list of common
                            questions.</span></li>
                        <li><a style={{ textDecoration: 'underline', color: 'black' }} href="https://www.medicare.gov/publications/search?field_publication_category_value=All&field_publication_language_value=All&keywords=02110" target="medicare"><span
                        id="atConsumerGuides_lblText">Consumer Guide</span></a> <span id="atConsumerGuidesDesc_lblText">
                            - A useful guide that explains Medicare Supplement Health Insurance.</span></li>
                        <li><a style={{ textDecoration: 'underline', color: 'black' }} id="lnkContactUs" href="https://floir.com/about-us/contact-us" target="floir_contact">
                        Contact Us</a> <span id="atContactUsDesc_lblText">- If you need assistance with this
                            website, please call the Consumer Helpline at <strong>1-877-693-5236.</strong></span></li>
                    <li><a style={{ textDecoration: 'underline', color: 'black' }} href="http://www.floir.com/" target="floir"><span id="atOIR_lblText">FLOIR Website</span> </a>
                        <span id="atOIRDesc_lblText">- Visit the Florida Office of Insurance Regulation website.</span>
                    </li>
                </ul>
            </div>
        );
    }
    };


export default connect(
    (state: ApplicationState) => state.rateSearch,
    RateSearchStore.actionCreators
)(Home as any);
